export default __webpack_public_path__ + "static/media/LogoMof.84ee16a7.svg";